var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.$can(_vm.ActionEnum.READ, _vm.ResourceEnum.THG_WORKITEMS))?_c('the-navigation-layout',{attrs:{"title":"Work","items":_vm.items}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }